import { Grid, GridProps } from '@mui/material';

export const GridContainer = (props: GridProps) => (
    <Grid container spacing={4} {...props} />
);
